import { render, staticRenderFns } from "./MyShop.vue?vue&type=template&id=13369ed2&scoped=true&"
import script from "./MyShop.vue?vue&type=script&lang=js&"
export * from "./MyShop.vue?vue&type=script&lang=js&"
import style0 from "./MyShop.vue?vue&type=style&index=0&id=13369ed2&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13369ed2",
  null
  
)

export default component.exports